/** Darstellung technischer Werte (design.md §3, Formate für technische Werte). */

const nf = new Intl.NumberFormat('de-DE');
export const formatNumber = (n: number) => nf.format(n);

/** `069a79f4-…-…a3ef` ⇒ `069a79f4…a3ef` */
export function shortUuid(uuid: string): string {
  const hex = uuid.replace(/-/g, '');
  return hex.length < 12 ? uuid : `${hex.slice(0, 8)}…${hex.slice(-4)}`;
}

/** `minecraft:diamond` ⇒ `{ ns: 'minecraft:', name: 'diamond' }` */
export function splitItemId(id: string): { ns: string; name: string } {
  const i = id.indexOf(':');
  return i === -1 ? { ns: '', name: id } : { ns: id.slice(0, i + 1), name: id.slice(i + 1) };
}

export const formatPos = (pos: readonly [number, number, number]) => pos.join(' / ');

export type DimensionKind = 'ow' | 'ne' | 'en' | 'other';

export function dimension(id: string): { kind: DimensionKind; label: string } {
  switch (id) {
    case 'minecraft:overworld':
      return { kind: 'ow', label: 'Oberwelt' };
    case 'minecraft:the_nether':
      return { kind: 'ne', label: 'Nether' };
    case 'minecraft:the_end':
      return { kind: 'en', label: 'End' };
    default:
      return { kind: 'other', label: id };
  }
}

const abs = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

/** `11.10.2026 14:03:12` */
export const absoluteTime = (iso: string) => abs.format(new Date(iso)).replace(',', '');

/** „gerade eben“, „vor 3 Min.“, „vor 2 Std.“, „vor 5 Tagen“, danach das Datum. */
export function relativeTime(iso: string, now = Date.now()): string {
  const s = Math.round((now - new Date(iso).getTime()) / 1000);
  if (s < 45) return 'gerade eben';
  const m = Math.round(s / 60);
  if (m < 60) return `vor ${m} Min.`;
  const h = Math.round(m / 60);
  if (h < 24) return `vor ${h} Std.`;
  const d = Math.round(h / 24);
  if (d === 1) return 'vor 1 Tag';
  if (d < 30) return `vor ${d} Tagen`;
  return absoluteTime(iso).slice(0, 10);
}

/** Codes in Gruppen: `7KQ2MX9P4R` ⇒ `7KQ2-MX9P-4R` (Server liefert sie meist schon formatiert). */
export function groupCode(code: string, groups: number[]): string {
  const raw = code.replace(/-/g, '');
  const out: string[] = [];
  let i = 0;
  for (const g of groups) {
    out.push(raw.slice(i, i + g));
    i += g;
  }
  if (i < raw.length) out.push(raw.slice(i));
  return out.filter(Boolean).join('-');
}
